<template>
  <div>

        <!-- header -->
        <Header />
        <!-- //header -->

        <!-- banner -->
        <Home />
        <!-- //banner -->
            
        <!-- about -->
        <About />
        <!-- //about -->

        <!-- services-->
        <Services />
        
        <!-- //services -->

        <!-- process -->
        <Experience />
        
        <!-- //process -->


        <!-- quote -->
        <section class="quote py-5">
            <div class="container py-lg-5">
                <div class="row">
                    <div class="col-lg-8" style="font-family: Garamond;">
                        <h4>" I had a Dream as a Programmer, now I am one of them. I feel so much <i><b>Passion</b></i> for this work and I love it.
                        Since the world is being transformed by the tecnology I am quit sure that I'll be part of those who will make part init's transformation in Mozambique, helping out the most as I can... "</h4>
                        <h5>designer - developer - freelancer</h5>
                        <img src="../../static/images/signature.png" alt="" class="img-fluid"/>
                    </div>
                </div>
            </div>
        </section>
        <!-- //quote -->

        <!-- portfolio -->
        <Portfolio />
        <!-- //portfolio -->

        <!--clients-->
        <!-- <Testimonials /> -->
        <Clients />
        
        <!--//clients-->

        <!-- Contact -->
        <Contact />
        
        
        <!-- //Contact -->		
                
        <!-- footer -->
        <Footer />
        
        <!-- //footer -->

        <!-- copyright -->
        <div class="copyright py-3 text-center">
            <div class="container">
                <p class="my-2">© 2019 Artur. Todos direitos reservados | Design by
                    <a href="http://explicado.co.mz"> Explicador Inc, LDA.</a>
                </p>
            </div>
        </div>
        <!-- copyright -->

        <!-- move top -->
        <div class="move-top text-right">
            <a href="#home" class="move-top"> 
                <span class="fa fa-angle-up  mb-3" aria-hidden="true"></span>
            </a>
        </div>
        <!-- move top -->
  </div>
</template>

<script>
import styles from '../../static/css/bootstrap.module.css'
import styles1 from '../../static/css/font-awesome.min.module.css'
import styles2 from '../../static/css/style.module.css'
import Header from './Header.vue'
import Home from './Home.vue'
import About from './About.vue'
import Experience from './Experience.vue'
import Clients from './Clients.vue'
import Portfolio from './Portfolio.vue'
import Services from './Services.vue'
import Testimonials from './Testimonials.vue'
import Contact from './Contact.vue'
import Footer from './Footer.vue'
export default {
  name: 'Index',
  components: {
    Header,
    Home,
    About,
    Experience,
    Clients,
    Portfolio,
    Services,
    Testimonials,
    Contact,
    Footer,
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index.vue